
import { defineComponent, reactive, ref } from 'vue';
import TelaPadraoCrud from '@/core/components/TelaPadraoCrud.vue';
import { useCrudBase } from '@/core/composables/CrudBase';
import { ECustomRenderRow } from '@/core/models/AntDesign/IColumn';
import { IOrdenacao } from '@/core/models/Consulta/IOrdenacao';
import { EPermissaoDados } from '@/models/Enumeradores/MeuSistema/Usuarios/EPermissaoDados';
import ImportacaoRegistrosExcelModal from '@/views/Cadastros/Produtos/ImportacaoRegistrosExcelModal.vue';
import storeSistema from '@/store/storeSistema';
import EngenhariaProdutoModal from './EngenhariaProdutoModal.vue';
import ServicoEngenhariaProduto from '@/servicos/Cadastros/PCP/ServicoEngenhariaProduto';

export default defineComponent({
  name: 'EngenhariaProduto',
  components: {
    TelaPadraoCrud,
    ImportacaoRegistrosExcelModal,
    EngenhariaProdutoModal,
  },
  setup() {
    const {
      crudBase, preencherEstrutura, exibirModal, sincronizaTelaCrud,
    } = useCrudBase();
    const servicoEngenhariaProduto = new ServicoEngenhariaProduto();
    const refCrudEngenhariaProduto = ref<InstanceType<typeof TelaPadraoCrud>>();

    crudBase.estrutura = preencherEstrutura();
    crudBase.estrutura.apresentarEmpresas = true;
    crudBase.estrutura.verificarCadastroCompartilhado = true;
    crudBase.estrutura.botaoPrincipalAcao = 'Novo';
    crudBase.estrutura.mensagemExclusao = 'Você confirma a exclusão da engenharia de produção:';
    crudBase.estrutura.colunasGrade = [
      {
        title: 'Identificador', dataIndex: 'codigo', key: 'Identificador', position: 0, visible: false, ordering: false,
      },
      {
        title: 'Código', dataIndex: 'codigo', key: 'codigo', position: 1, visible: true, ordering: true, fixed: 'left', ellipsis: true, align: 'left', customRenderRow: ECustomRenderRow.LinkAcao,
      },
      {
        title: 'Descrição', dataIndex: 'nome', key: 'Nome', position: 2, visible: true, ordering: true, fixed: 'left', ellipsis: true, width: 300, align: 'left', customRenderRow: ECustomRenderRow.LinkAcao,
      },
      {
        title: 'Quantidade', dataIndex: 'quantidadeFormula', key: 'Quantidade', position: 3, visible: true, align: 'left', customRenderRow: ECustomRenderRow.MascararFracionado,
      },
      {
        title: 'Ativo', dataIndex: 'ativo', key: 'Ativo', position: 3, visible: true, align: 'left', customRenderRow: ECustomRenderRow.TagAtivo,
      },
      {
        title: 'Ações', key: 'acoes', position: 4, visible: true, fixed: 'right', width: 120, align: 'center', customRenderRow: ECustomRenderRow.IconeAcoes,
      },
    ];
    crudBase.estrutura.ordenacaoPadraoGrade.push({ identificador: 'IdentificadorProduto', ordem: 'DESC' } as IOrdenacao);

    const state = reactive({
      exibirImportacaoExcel: false,
    });

    function abrirImportacaoRegistros() {
      state.exibirImportacaoExcel = true;
    }

    async function sincronizarRegistro(acao: EPermissaoDados, codigoRegistro: number) {
      if (refCrudEngenhariaProduto.value !== undefined) {
        await refCrudEngenhariaProduto.value.sincronizarRegistro(acao, codigoRegistro);
      }
    }
    return {
      state,
      storeSistema,
      crudBase,
      servicoEngenhariaProduto,
      refCrudEngenhariaProduto,
      exibirModal,
      sincronizaTelaCrud,
      sincronizarRegistro,
      abrirImportacaoRegistros,
    };
  },
});
